import React from 'react';

import { Typography } from '@material-ui/core';
import { isUndefined } from 'lodash';

import Catch from '../Catch';

type Props = {
  children?: React.ReactNode;
  fallback?: React.ReactNode;
};

function ErrorBoundary({ children, fallback }: Props, error?: Error) {
  if (error) {
    return isUndefined(fallback) ? (
      <div className="error-screen">
        <Typography>An error has occured</Typography>
        <Typography variant="caption">{error.message}</Typography>
      </div>
    ) : (
      <>{fallback}</>
    );
  }
  return <>{children}</>;
}

export default Catch(ErrorBoundary);
